var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "49px",
    viewBox: "0 0 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "90E6D92F-C2B8-4809-91C0-360F13648176") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Previews",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    transform: "translate(-445.000000, -3261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row",
    transform: "translate(283.000000, 3253.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hamburger-/-48",
    transform: "translate(162.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    fillOpacity: 0,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "square",
    transform: "translate(13.000000, 16.500000)",
    stroke: "#111111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5 L22,7.5 M0,0.5 L22,0.5 M0,14.5 L22,14.5",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger48);
export default __webpack_public_path__ + "static/media/hamburger-48.44fb6a462716be0956cbe62fedaf2ce8.svg";
export { ForwardRef as ReactComponent };